/**
 * Catálogo de áreas de la app y de la fase en que llega cada una.
 *
 * Las áreas de fases posteriores existen desde ya como marcadores de posición,
 * para que la navegación completa se pueda probar en el teléfono y quede claro
 * qué trae cada fase (design.md, sección 12.1). Patrón de Control de Negocio
 * de Comida.
 *
 * Orden decidido por Janeth el 22 oct 2026: Fase 1 Nutrición y metas por
 * etapa, Fase 2 Gym, Fase 3 Cuerpo y Fase 4 Ayuno y mantenimiento estimado.
 */

import {
  Activity,
  CalendarRange,
  Dumbbell,
  Flame,
  Sheet,
  Utensils,
  type LucideIcon,
} from 'lucide-react';

export interface AreaApp {
  ruta: string;
  titulo: string;
  /** Ícono de trazo fino de Foco (Lucide, incluido en la app). */
  icono: LucideIcon;
  descripcion: string;
  fase: number;
  /** Qué trae la fase, para el marcador de posición. */
  contenido: string;
}

/** Fase en construcción. */
export const FASE_ACTUAL = 3;

/** true si el área ya está construida o se está construyendo. */
export function disponible(area: Pick<AreaApp, 'fase'>): boolean {
  return area.fase <= FASE_ACTUAL;
}

export const AREAS: readonly AreaApp[] = [
  {
    ruta: '/gym',
    titulo: 'Gym',
    icono: Dumbbell,
    descripcion: 'Rutinas, entrenamientos y descanso',
    fase: 2,
    contenido:
      'Catálogo de ejercicios en español, rutinas, entrenamiento con "la vez pasada", temporizador de descanso, pantalla encendida e historial.',
  },
  {
    ruta: '/cuerpo',
    titulo: 'Cuerpo',
    icono: Activity,
    descripcion: 'Peso, tendencia y medidas',
    fase: 3,
    contenido:
      'Básculas con su unidad, pesajes en kg o lb, tendencia de 7 días, IMC, gráfica con las etapas del plan y medidas corporales.',
  },
  {
    ruta: '/comida',
    titulo: 'Comida',
    icono: Utensils,
    descripcion: 'Lo que comes y tu ayuno',
    fase: 1,
    contenido:
      'Registro por tiempo de comida, base de alimentos en español sin conexión, Mis alimentos y totales contra tu meta. El ayuno llega en la Fase 4.',
  },
  {
    ruta: '/mas/plan',
    titulo: 'Mi plan',
    icono: CalendarRange,
    descripcion: 'Etapas de déficit, mantenimiento y superávit',
    fase: 1,
    contenido: 'Tu plan con sus fechas, la etapa de cada día y sus metas, con el historial de lo anterior.',
  },
  {
    ruta: '/mas/mantenimiento',
    titulo: 'Mantenimiento',
    icono: Flame,
    descripcion: 'Tus calorías de mantenimiento',
    fase: 1,
    contenido:
      'Tu mantenimiento capturado a mano, con historial. La fórmula y el estimado con tus datos llegan en la Fase 4.',
  },
  {
    ruta: '/mas/excel',
    titulo: 'Exportar a Excel',
    icono: Sheet,
    descripcion: 'Tus datos en hojas de cálculo',
    fase: 5,
    contenido: 'Entrenamientos, pesajes, medidas, comidas, ayunos y etapas en un archivo de Excel.',
  },
];

export function areaDe(ruta: string): AreaApp | undefined {
  return AREAS.find((a) => a.ruta === ruta);
}
